import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { MDText } from 'i18n-react';

import ErrorPage from '@adsk/bim360-matrix-react-error-page';

import { withLocale, TSymbolProp } from '@adsk/bim360-matrix-react-helpers/es/locale';

import './_MaintenancePage.scss';

/**
 * @class MaintenancePage
 **/
export class MaintenancePage extends PureComponent {
  /**
   * @constructor CustomComponent
   **/
  constructor(props) {
    super(props);

    this.renderDefault = this.renderDefault.bind(this);
    this.renderMessage = this.renderMessage.bind(this);
    this.renderTime = this.renderTime.bind(this);

    this.state = {
      renderContentType: this.getRenderContentType(props)
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    this.setState({ renderContentType: this.getRenderContentType(nextProps) });
  }

  getRenderContentType(props) {
    if ('message' in props) {
      return this.renderMessage;
    } else if ('to' in props && 'from' in props) {
      return this.renderTime;
    } else {
      return this.renderDefault;
    }
  }

  renderDefaultTile(
    titleTranslationKey = 'DEFAULT_MESSAGE_TITLE',
    descriptionTranslationKey = 'DEFAULT_MESSAGE_DESCRIPTION'
  ) {
    return (
      <div>
        <div className="MaintenancePage__message-title">
          {this.props[TSymbolProp].translate(titleTranslationKey)}
        </div>
        <div className="MaintenancePage__message-description">
          {this.props[TSymbolProp].translate(descriptionTranslationKey)}
        </div>
      </div>
    );
  }

  renderDefaultFooter() {
    return (
      <div className="MaintenancePage__message-footer">
        <p>
          {this.props[TSymbolProp].translate('DEFAULT_MESSAGE_FOOTER_FIRST_LINE', {
            HDS: (
              <a href="https://health.autodesk.com/" target="_blank" rel="noopener noreferrer">
                {this.props[TSymbolProp].translate('DEFAULT_MESSAGE_HDS_TITLE')}
              </a>
            )
          })}
        </p>
        <p>{this.props[TSymbolProp].translate('DEFAULT_MESSAGE_FOOTER_SECOND_LINE')}</p>
      </div>
    );
  }

  renderDefault() {
    return (
      <div className="MaintenancePage__message">
        {this.renderDefaultTile()}
        {this.renderDefaultFooter()}
      </div>
    );
  }

  renderTime() {
    return (
      <div className="MaintenancePage__message">
        {this.renderDefaultTile('TIME_MESSAGE_TITLE', 'TIME_MESSAGE_DESCRIPTION')}
        <div className="MaintenancePage__message-body-time">
          <div>
            {this.props[TSymbolProp].translate('TIME_MESSAGE_BODY_FIRST_LINE', {
              from: this.props.from
            })}
          </div>
          <div>
            {this.props[TSymbolProp].translate('TIME_MESSAGE_BODY_SECOND_LINE', {
              to: this.props.to
            })}
          </div>
        </div>
        {this.renderDefaultFooter()}
      </div>
    );
  }

  renderMessage() {
    return this.props.message;
  }

  /**
   * Render
   * @returns {VDOM}
   **/
  render() {
    return (
      <ErrorPage
        renderContent={this.state.renderContentType}
        errorIconProps={{ 'data-testid': 'MaintenancePage__error-image' }}
      />
    );
  }
}

MaintenancePage.propTypes = {
  /**
   * Information about the start of the maintenance downtime
   */
  to: PropTypes.string,
  /**
   * Information about the end of the maintenance downtime
   */
  from: PropTypes.string,
  /**
   * A custom message if either the default message or to/from aren't enough
   */
  message: PropTypes.node,
  /**
   * Locale for the component, defaults to english.
   */
  locale: PropTypes.string
};

export default withLocale(
  MaintenancePage,
  ({ locale }) => new MDText(require(`./i18n/${locale}.json`))
);
